/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Vehicle_Filter_LabelInputs */

const fr_network_vehicle_filter_label = /** @type {(inputs: Network_Vehicle_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer par`)
};

const en_network_vehicle_filter_label = /** @type {(inputs: Network_Vehicle_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by`)
};

/**
* | output |
* | --- |
* | "Filter by" |
*
* @param {Network_Vehicle_Filter_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicle_filter_label = /** @type {((inputs?: Network_Vehicle_Filter_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicle_Filter_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicle_filter_label(inputs)
	return en_network_vehicle_filter_label(inputs)
});